import { render, staticRenderFns } from "./mtp-status-flagged-modal.vue?vue&type=template&id=d1bca612"
import script from "./mtp-status-flagged-modal.ts?vue&type=script&lang=ts&external"
export * from "./mtp-status-flagged-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./mtp-status-flagged-modal.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1bca612')) {
      api.createRecord('d1bca612', component.options)
    } else {
      api.reload('d1bca612', component.options)
    }
    module.hot.accept("./mtp-status-flagged-modal.vue?vue&type=template&id=d1bca612", function () {
      api.rerender('d1bca612', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-input/mtp-status-flagged-modal/mtp-status-flagged-modal.vue"
export default component.exports